export enum Color {
  White,
  Black,
}
